<template>
<div>
    <header class="header">   
      <nav class="navbar navbar-expand-lg">
        <!-- <div class="search-panel">
          <div class="search-inner d-flex align-items-center justify-content-center">
            <div class="close-btn">Kapat <i class="fa fa-close"></i></div>
            <form id="searchForm" action="#">
              <div class="form-group">
                <input type="search" name="search" placeholder="Genel arama yapabilirsiniz">
                <button type="submit" class="submit">Ara</button>
              </div>
            </form>
          </div>
        </div> -->
        <div class="container-fluid d-flex align-items-center justify-content-between">
          <div class="navbar-header">
            <!-- Navbar Header-->
            <router-link to="/" class="navbar-brand">
              <div class="brand-text brand-big visible"><strong class="text-primary">{{fad}}</strong></div>
              <div class="brand-text brand-sm"><strong class="text-primary"></strong><strong></strong></div>
              </router-link>
            <!-- Sidebar Toggle Btn-->
            <button class="sidebar-toggle"><i class="fa fa-long-arrow-left"></i></button>
          </div>
          <div class="right-menu list-inline no-margin-bottom">    
            <!-- <div class="list-inline-item">
              <a href="#" class="search-open nav-link">
                <i class="icon-magnifying-glass-browser"></i>
              </a>
            </div> -->

            <!-- Tasks-->
            <div class="list-inline-item dropdown">
             <!-- <router-link to="/">Anasayfa</router-link>-->
            </div>
            <div class="list-inline-item dropdown">
             <!-- <router-link to="/">Guide</router-link>-->
            </div>
            <div class="list-inline-item dropdown">
             <!-- <a id="navbarDropdownMenuLink2" href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="nav-link tasks-toggle">Sağlayıcıdan<span class="badge dashbg-3">0</span>
              </a>-->
            </div>
            <!-- Tasks end-->
            <!-- Log out-->            <div class="list-inline-item logout">
              
              <a   href="javascript:void(0)" class="nav-link"> 
                <router-link to="/aktarim"><i class="icon-settings mr-2"></i>Yüklemeler</router-link>
              </a>
            </div> 
            <div class="list-inline-item logout">
              
              <a @click="cikis()"  id="logout" href="javascript:void(0)" class="nav-link"> 
                <span class="d-none d-sm-inline">Güvenli Çıkış</span>
                <i class="icon-logout"></i>
              </a>
            </div>
           
          </div>
        </div>
      </nav>
    </header>
</div>
</template>
<script lang="js">

export default{
  props: {
    fad: {
      type: String,
    },
    cikis:{
      type:Function
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/component/header.vue